let originalPaymentIntentFulfilledOrIntercepted = false;
localStorage.setItem('oneOffStopCartForwarding', false); // always start fresh
localStorage.setItem('oneOffKeepCartClosed', false);// always start fresh

function popupAddToCartAndProceed(popupType,index,formId,proceed=true){
 
  //console.log('popupAddToCartAndProceed called');
  upsellAddOriginalToCart(formId);
  popupCloseOrNext(popupType,index,formId);
}

function upsellAddOriginalToCart(formId,keepCartClosed=true,stopCartForwarding=true){ // in other words: the upsell(s) was not successful/accepted
  //console.log(formId);
  //console.log('upsellAddOriginalToCart called');
  const mainCartForm = document.getElementById(formId);
  if(mainCartForm){
    if(!originalPaymentIntentFulfilledOrIntercepted){ // prevent the non-upsell product to be added twice
        
      const realAtcButton = mainCartForm.querySelector('.product-form__submit.real-atc');
      localStorage.setItem('oneOffKeepCartClosed', keepCartClosed);
      localStorage.setItem('oneOffStopCartForwarding', stopCartForwarding);
  
      if(realAtcButton){
        realAtcButton.click();
        originalPaymentIntentFulfilledOrIntercepted = true;
      }
    }
  }
}
function calculateCloseOrNextForPopups(index){
  const allPopups = document.querySelectorAll('.product-popups-container .a-popup-container');
  let closeOrNext;
  if(allPopups.length == 1){
    closeOrNext = 'close';
  }else{
    // find my position and the next popup to show
    allPopups.forEach(tmpPopup => {
      closeOrNext = 'next';
      // am I already the last in the queue? then it is time to close all
      const forPopupIndex = tmpPopup.getAttribute('data-index');
     // console.log('forPopupIndex ', forPopupIndex);
      // is this me? am I the last in the row?
      if(forPopupIndex == index){
        if(forPopupIndex == (allPopups.length - 1)) // I am the last in the row, we can close all
          closeOrNext = 'close';
      }
    });
  }

  return closeOrNext;
}
function popupCloseOrNext(popupType,index,formId=undefined){
  //console.log('popupCloseOrNext called');
  //console.log('Original Payment Intent Fulfilled or Intercepted? ', originalPaymentIntentFulfilledOrIntercepted);
  // unless there are more popups in the queue
  const allPopups = document.querySelectorAll('.product-popups-container .a-popup-container');
  let closeOrNext = calculateCloseOrNextForPopups(index);
  
  
  if(closeOrNext == 'close'){
    const popupBlur = document.getElementById('popup-blur');
    popupBlur.classList.add('hidden');
  
    const popupContainer = document.querySelector('.a-popup-container[data-ident="'+popupType+'"]');
    popupContainer.classList.add('hidden');

    // was the original intent fulfilled?
    // if not, do it now before closing all popups
    if(!originalPaymentIntentFulfilledOrIntercepted){
    //  console.log('Original Intent was NOT fulfilled. We are doing it now');
      // for this we also want to reset all blocking cart forwarding or opening
      localStorage.setItem('oneOffKeepCartClosed', false);
      localStorage.setItem('oneOffStopCartForwarding', false);
     // console.log('upsellAddOriginalToCart deferred');
      upsellAddOriginalToCart(formId,false,false);
    }else{
     // console.log('Original Intent was fulfilled. We can go to cart now');
      eventuallyGoToCart(formId);
    }
      
    
  }

  if(closeOrNext == 'next'){
    //console.log('next');
    const popupContainer = document.querySelector('.a-popup-container[data-ident="'+popupType+'"]');
    popupContainer.classList.add('hidden');

    const nextIndex = index + 1;
    //console.log('next index ', nextIndex);
    allPopups[nextIndex].classList.remove('hidden');
  }
}
function upsellAddToCart(variantId,quantity,popupType,index,formId=undefined){
  //console.log('upsellAddToCart called');
  const theRelevantPopup = document.querySelector(`.a-popup-container[data-ident="` + popupType+ `"][data-index="` + index+ `"]`);
  const theRelevantPopupSubmitButton = theRelevantPopup.querySelector('button.button--primary');
  //console.log(theRelevantPopup);
  
  if(theRelevantPopup){
    
    if(theRelevantPopupSubmitButton){
      if (theRelevantPopupSubmitButton.getAttribute('aria-disabled') === 'true') return;
      
      theRelevantPopupSubmitButton.setAttribute('aria-disabled', true);
      theRelevantPopupSubmitButton.classList.add('loading');
      theRelevantPopupSubmitButton.querySelector('.loading__spinner').classList.remove('hidden');
    }
  }

  // is this an electric or historic license plate?
  let suffix = '';

  if (productMetafields.is_electric) {
    suffix = 'E';
  } else if (productMetafields.is_historic) {
    suffix = 'H';
  }else{
    
  }
  const fullLicenseText = areaCodeInput.value.toUpperCase() + '-' + lettersInput.value.toUpperCase() + '' + digitsInput.value+''+suffix;

  // if the variant is a keychain, then we have to add the customizations
  let additionalProperties = {}
  if(variantId == '49262644298076'){
    additionalProperties = {
      'Aufdruck': fullLicenseText
    };
  }
  // if the variant is an emission sticker, then we have to add the customizations
  if(popupType == 'emission_sticker'){
    additionalProperties = {
      'Aufdruck': fullLicenseText,
      '_licenseArea': areaCodeInput.value.toUpperCase(),
      '_licenseLetters': lettersInput.value.toUpperCase(),
      '_licenseDigits': digitsInput.value,
      '_isElectric': productMetafields.is_electric
    };
  }
  
  const myCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  let sections;
  if (myCart) {
    sections = myCart.getSectionsToRender().map((section) => section.id);
    myCart.setActiveElement(document.activeElement);
  }
  
  const body = JSON.stringify({
    sections: sections,
    sections_url: window.location.pathname,
    id: variantId, 
    quantity: quantity,
    properties: {
        _upsellSource: 'popup',
        ...additionalProperties
      }
  });
  //console.log(body);
  fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
  .then((response) => {
    return response.text();
  })
  .then((state) => {
    const parsedState = JSON.parse(state);
    
    const cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    //console.log('cartData', parsedState);
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'upsell-popup',
      productVariantId: variantId,
      cartData: parsedState,
    });
    if (window.innerWidth > 900) {
      myCart.renderContents(parsedState,false); // this only renders the contents, but does not open the cart drawer yet
    }else{
    }
   
    popupCloseOrNext(popupType,index,formId);
  })
  .catch(error => console.error('Error:', error))
  .finally(() => {
    if (window.innerWidth > 900) {
      theRelevantPopupSubmitButton.classList.remove('loading');
      theRelevantPopupSubmitButton.querySelector('.loading__spinner').classList.add('hidden');
    }
    if (myCart && myCart.classList.contains('is-empty')) myCart.classList.remove('is-empty');
    //if (!this.error) 
    theRelevantPopupSubmitButton.removeAttribute('aria-disabled');
  });
}


function upgradeToCarbon(popupType,index){
  //console.log('upgradeToCarbon called');
  const theRelevantPopup = document.querySelector(`.a-popup-container[data-ident="` + popupType+ `"][data-index="` + index+ `"]`);
  const theRelevantPopupSubmitButton = theRelevantPopup.querySelector('button.button--primary');
  //console.log(theRelevantPopup);
  
  if(theRelevantPopup){
    
    if(theRelevantPopupSubmitButton){
      if (theRelevantPopupSubmitButton.getAttribute('aria-disabled') === 'true') return;
      
      theRelevantPopupSubmitButton.setAttribute('aria-disabled', true);
      theRelevantPopupSubmitButton.classList.add('loading');
      theRelevantPopupSubmitButton.querySelector('.loading__spinner').classList.remove('hidden');
    }
  }
  
  const currentlySelectedVariantId = document.querySelector('.product-variant-id').value;
  const variantDataTmp = document.querySelector('#product_variant_data');
  const variantElement = variantDataTmp.querySelector(`[data-variant-id="` + currentlySelectedVariantId+ `"]`);
  const sizeHelper = document.querySelector(`.size-helper[data-variant-id="` + currentlySelectedVariantId+ `"]`);
  const quantitySelectElement = document.querySelector('#quantity-select');
  const quantityValue = quantitySelectElement.value;
  //console.log(sizeHelper);
  let widthOfVariant;
  let heightOfVariant;
  if(sizeHelper){
    widthOfVariant = sizeHelper.getAttribute('data-variant-width');
    heightOfVariant = sizeHelper.getAttribute('data-variant-height');
  }

  // now find the upsell variant at the same size
  const relatedCarbonVariantElement = document.querySelector(`#carbon_upsell_product_variant_data span[data-variant-width="` + widthOfVariant+ `"][data-variant-height="` + heightOfVariant+ `"]`);
  if(relatedCarbonVariantElement){
    const relatedCarbonVariantId = relatedCarbonVariantElement.getAttribute('data-variant-id');
    const relatedCarbonProductTitle = relatedCarbonVariantElement.getAttribute('data-product-title');
    const relatedCarbonVariantTitle = relatedCarbonVariantElement.getAttribute('data-variant-title');
    //console.log('Upgrading to ', relatedCarbonVariantId, relatedCarbonProductTitle, relatedCarbonVariantTitle, quantityValue);

    const upsellLicenseArea = areaCodeInput.value;
    const upsellLicenseLetters = lettersInput.value;
    const upsellLicenseDigits = digitsInput.value;

    let upsellSeasonStart;
    let upsellSeasonEnd;
    
    if(document.getElementById("season-start-select"))
    upsellSeasonStart = document.getElementById("season-start-select").value;
    
    if(document.getElementById("season-end-select"))
    upsellSeasonEnd = document.getElementById("season-end-select").value;


    // is this an electric or historic license plate?
    let suffix = '';

    if (productMetafields.is_electric) {
      suffix = 'E';
    } else if (productMetafields.is_historic) {
      suffix = 'H';
    }else{
      
    }

    const fullLicenseText = areaCodeInput.value.toUpperCase() + '-' + lettersInput.value.toUpperCase() + '' + digitsInput.value+''+suffix;
    const myCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    let sections;
    if (myCart) {
      sections = myCart.getSectionsToRender().map((section) => section.id);
      myCart.setActiveElement(document.activeElement);
    }

    let properties = {
        _licenseArea: upsellLicenseArea,
        _licenseLetters: upsellLicenseLetters,
        _licenseDigits: upsellLicenseDigits,
        _upsellSource: 'popup',
        'Kennzeichentext': fullLicenseText
      };

    if (upsellSeasonStart > 0 && upsellSeasonEnd > 0) {
      properties._licenseSeasonStart = upsellSeasonStart;
      properties._licenseSeasonEnd = upsellSeasonEnd;
      properties['Saison'] = upsellSeasonStart + '-' + upsellSeasonEnd;
    }

    
    const body = JSON.stringify({
      sections: sections,
      sections_url: window.location.pathname,
      id: relatedCarbonVariantId, 
      quantity: quantityValue,
      properties: properties
    });
    //console.log(body);
    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      originalPaymentIntentFulfilledOrIntercepted = true;
      const cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      //console.log('cartData', parsedState);
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'upsell-popup',
        productVariantId: relatedCarbonVariantId,
        cartData: parsedState,
      });
      if (window.innerWidth > 900) {
        myCart.renderContents(parsedState,false); // this only renders the contents, but does not open the cart drawer yet
      }else{
      }
     
      popupCloseOrNext(popupType,index);
    })
    .catch(error => console.error('Error:', error))
    .finally(() => {
      if (window.innerWidth > 900) {
        theRelevantPopupSubmitButton.classList.remove('loading');
        theRelevantPopupSubmitButton.querySelector('.loading__spinner').classList.add('hidden');
      }
      if (myCart && myCart.classList.contains('is-empty')) myCart.classList.remove('is-empty');
      //if (!this.error) 
      theRelevantPopupSubmitButton.removeAttribute('aria-disabled');
    });
  }
}

function eventuallyGoToCart(formId = undefined){
  //console.log('eventuallyGoToCart called');
  originalPaymentIntentFulfilledOrIntercepted = false; // we can reset this as the upsell popups have cycled through and anything from here on is a new upsell attempt
  const myCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  // we can only go to cart when all popups have cycled through
  if (window.innerWidth > 900) {
    if(myCart)
      myCart.open();
  }else{
    //find the primary CTA button and add a loading spinner
    const mainCartForm = document.getElementById(formId);
    if(mainCartForm){
      //console.log('mainCartForm given');
      const realAtcButton = mainCartForm.querySelector('button.real-atc');
      const fakeAtcButton = mainCartForm.querySelector('button.fake-atc');

      realAtcButton.classList.add('loading');
      fakeAtcButton.classList.add('loading');

      realAtcButton.querySelector('.loading__spinner').classList.remove('hidden');
      fakeAtcButton.querySelector('.loading__spinner').classList.remove('hidden');

      realAtcButton.setAttribute('aria-disabled', true);
      fakeAtcButton.setAttribute('aria-disabled', true);

    }
    setTimeout(() => {
      window.location="/cart";
      
    },1500);
  }
}

document.addEventListener("DOMContentLoaded", () => {
    const materialElements = document.querySelectorAll('.product__wrapper .product__info-wrapper .product-info__left .product-info__left-material .material__wrapper .product-material');
    //const changeSizeButton = document.querySelector('.product__wrapper .product__info-wrapper .product-info__left .product-info__left-material .material-size__wrapper button.change-size');
    const sizeOptions = document.querySelector('.product__wrapper .product__info-wrapper .product-info__left .product-info__left-material .material-size__wrapper .size-option');
    const quantitySelect = document.querySelector('.product__wrapper .product__info-wrapper .product-info__left .product-info__left-quantity .quantity-select select#quantity-select');
    const atcButton = document.querySelector('.product__wrapper .product__info-wrapper .product-info__left .product-info__left-buy-button .buy-button__wrapper .atc-button__main button.real-atc');
    const atcButtonFake = document.querySelector('.product__wrapper .product__info-wrapper .product-info__left .product-info__left-buy-button .buy-button__wrapper .atc-button__main button.fake-atc');
    const priceElement = document.querySelector('.product__wrapper .product__info-wrapper .product-info__right .product-price .main-price span');
    const variantData = document.querySelector('#product_variant_data');
    
    const areaCodeInput = document.getElementById("areaCodeInput");
    const lettersInput = document.getElementById("lettersInput");
    const digitsInput = document.getElementById("digitsInput");

    const seasonStartSelect = document.getElementById("season-start-select");
    const seasonEndSelect = document.getElementById("season-end-select");

    const areaCodePreview = document.getElementById("areaCode");
    const areaImage = document.getElementById("areaImage");
    const lettersPreview = document.getElementById("letters");
    const digitsPreview = document.getElementById("digits");
    const suffixPreview = document.getElementById("suffix");

    const backToTopButton = document.getElementById("backToTop");
    const carbonUpsellCheckbox = document.getElementById("carbon-upsell-checkbox");
  

    
    const inputErrorMessage = document.querySelector('.product__wrapper .product__info-wrapper .product-info__left .product-info__left-license-number .plate-input__wrapper .error-container');
    const inputErrorMessage2 = document.querySelector('.product__wrapper .product__info-wrapper .product-info__left .product-info__left-license-number .plate-input__wrapper .error-container_2');

    materialElements.forEach((material) => {
      material.addEventListener('click', () => {
        if (material.classList.contains('active')) {
          event.preventDefault();
        } else {
          const handle = material.getAttribute('handle');
          const prependArea = areaCodeInput.value;
          const prependLetters = lettersInput.value;
          const prependDigits = digitsInput.value;

          let prependSeasonStart = 0;
          if(seasonStartSelect)
          prependSeasonStart = seasonStartSelect.value;
          
          let prependSeasonEnd = 0;
          if(seasonEndSelect)
          prependSeasonEnd = seasonEndSelect.value;
          
          let newHref = window.location.origin + `/products/${handle}`;

          var url = new URL(newHref);
          if(prependArea)
            url.searchParams.append('area',prependArea);
          if(prependDigits)
            url.searchParams.append('digits',prependDigits);
          if(prependLetters)
            url.searchParams.append('letters',prependLetters);
          if(prependSeasonStart)
            url.searchParams.append('start',prependSeasonStart);
          if(prependSeasonEnd)
            url.searchParams.append('end',prependSeasonEnd);
          
          window.location.href = url;
        }
      });
    });

   
    

    function checkForPrefilling(){
      var preAreaCode = getUrlParameter('area');
      var preLetters = getUrlParameter('letters');
      var preDigits = getUrlParameter('digits');
      var preSeasonStart = getUrlParameter('start');
      var preSeasonEnd = getUrlParameter('end');
      var preSize = getUrlParameter('size');
      var preVariantId = getUrlParameter('variant');
      var preVariantWidth = getUrlParameter('width');
      var preVariantHeight = getUrlParameter('height');

      if(preAreaCode){
        areaCodeInput.value=preAreaCode.toUpperCase();
      }

      if(preLetters){
        lettersInput.value=preLetters.toUpperCase();
      }

      if(preDigits){
        digitsInput.value=preDigits;
      }

      if(preSeasonStart){
        seasonStartSelect.value=preSeasonStart;
      }

      if(preSeasonEnd){
        seasonEndSelect.value=preSeasonEnd;
      }

      if(preVariantId){ // this takes priority as it is used for deeplinking from e.g. SERPs
        const sizeOptions = document.querySelector('#size-select');
        if(checkIfSelectValueExists(sizeOptions,preVariantId)){
          sizeOptions.value = preVariantId;
          whenSizeChanges();
        }
      }else{
        if(preVariantWidth && preVariantHeight){
          // find the corresponding variant id
          const sizeHelper = document.querySelector(`.size-helper[data-variant-width="` + preVariantWidth+ `"][data-variant-height="` + preVariantHeight+ `"]`);
          if(sizeHelper){
            const relatedVariantId = sizeHelper.getAttribute('data-variant-id');
           // console.log('Related Variant ID: ',relatedVariantId);
            if(relatedVariantId){
              const sizeOptions = document.querySelector('#size-select');
              if(checkIfSelectValueExists(sizeOptions,relatedVariantId)){
                sizeOptions.value = relatedVariantId;
                whenSizeChanges();
              }
            }
          }
        }
      }
    }


  function checkIfSelectValueExists(selectElement, valueToCheck) {
      // Get the select element by its ID
      
      // Loop through all options in the select element
      for (let i = 0; i < selectElement.options.length; i++) {
          if (selectElement.options[i].value === valueToCheck) {
              // If the value matches, return true
              return true;
          }
      }
      
      // If no match is found, return false
      return false;
  }
    
   function displayTooltipHintForMenu(){

      let content = '<i class="fa-duotone fa-solid fa-circle-info tooltip-trigger" style="--fa-primary-color: #53678C; --fa-secondary-color: #53678C;"></i> <strong>Gewusst?</strong> Weitere Kennzeichen findest du hier...';
      let tooltipTrigger = document.querySelector('.header__icon--menu');
      let tooltipTriggerTarget = document.querySelector('div');
      //console.log(tooltipTrigger);
      tippy(tooltipTrigger, {
          placement: 'bottom', // You can change this to 'bottom', 'left', or 'right'
          //interactive: true,
          //hideOnClick: true,
          allowHTML: true,
          showOnCreate: true,
          arrow: true,
          trigger: 'click',
          triggerTarget: tooltipTriggerTarget,
          //appendTo: ,
          content: content,
          animation: 'fade',
          theme: 'light',
          delay: [4000, 100]
      });
      
    }

    
    function initTooltipsForFeatures(){

      var tooltipElements = document.querySelectorAll('.featured-product .info-button');
      tooltipElements.forEach((element) => {
        let tmpHTML = element.querySelector('.tooltip-content').innerHTML;
        let tooltipTrigger = element.querySelector('i');
        //console.log(tooltipTrigger);
        tippy(tooltipTrigger, {
            //placement: 'top', // You can change this to 'bottom', 'left', or 'right'
            //interactive: true,
            //hideOnClick: true,
            allowHTML: true,
            arrow: true,
            trigger: 'click',
            content: tmpHTML,
            animation: 'fade',
            theme: 'light',
            delay: [100, 100]
        });
      });
      
    }

    function initTooltipsForCertificates(){

      var tooltipElements = document.querySelectorAll('.icon-text .text.certification');
      tooltipElements.forEach((element) => {
        //console.log(tooltipElements);
        let tmpHTML = element.querySelector('.tooltip-content').innerHTML;
        let tooltipTrigger = element.querySelector('i');
        //console.log(tooltipTrigger);
        tippy(tooltipTrigger, {
            //placement: 'top', // You can change this to 'bottom', 'left', or 'right'
            interactive: true,
            //hideOnClick: true,
            allowHTML: true,
            arrow: true,
            trigger: 'click',
            content: tmpHTML,
            animation: 'fade',
            theme: 'light',
            delay: [100, 100]
        });
      });
      
    }

    function initTooltipsForShipping(){

      var tooltipElements = document.querySelectorAll('.shipping-tax-container');
      tooltipElements.forEach((element) => {
        //console.log(tooltipElements);
        let tmpHTML = element.querySelector('.tooltip-content').innerHTML;
        let tooltipTrigger = element.querySelector('.tooltip-trigger');
        tippy(tooltipTrigger, {
            //placement: 'top', // You can change this to 'bottom', 'left', or 'right'
            interactive: true,
            //hideOnClick: true,
            allowHTML: true,
            arrow: true,
            trigger: 'click',
            content: tmpHTML,
            animation: 'fade',
            theme: 'light',
            delay: [100, 100]
        });
      });
      
    }

    const newsletterSignupTriggers = document.querySelector('.newsletter-signup-trigger');
    newsletterSignupTriggers.addEventListener("click", function() {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'VrNJ2f']);
    });
    
    backToTopButton.addEventListener("click", function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
    
    function initSizeDummy(){
      const sizeOptions = document.querySelector('#size-select');
      const sizeOptionsDummy = document.querySelector('.size-option-dummy');

      sizeOptionsDummy.value = sizeOptions.value;  
    }
    function replaceSelectOptions(selectId, newOptions) {
      const selectElement = document.getElementById(selectId);
      const previouslySelectedValue = selectElement.value;
      // Clear existing options
      selectElement.innerHTML = '';

      // Add new options
      newOptions.forEach(option => {
        const newOptionElement = document.createElement('option');
        newOptionElement.value = option.value;
        newOptionElement.text = option.text;
        selectElement.appendChild(newOptionElement);
      });
      selectElement.value = previouslySelectedValue;
    }

    function checkForUpsellInterceptors(){
      //console.log('Checking for Upsell Interceptors');
      const allPopups = document.querySelectorAll('.product-popups-container .a-popup-container');
      //console.log(allPopups.length);
      if(allPopups.length > 0){
        const atcMainButtonContainer = document.querySelector('.atc-button__main');
        atcMainButtonContainer.classList.add('intercepted');
        atcButtonFake.addEventListener('click', () => {
          if(atcButtonFake.getAttribute('aria-disabled') === 'true') return;
          launchUpsellPopups();
        });
      }
    }

    function launchUpsellPopups(index=0){
      const popupBlur = document.getElementById('popup-blur');
      popupBlur.classList.remove('hidden');

      const allPopups = document.querySelectorAll('.product-popups-container .a-popup-container');
      allPopups[index].classList.remove('hidden');
      const identOfIndexedPopup = allPopups[index].getAttribute('data-ident');
      const hiddenHelperCurrentlyActivePopup = document.querySelector('.currently-visible-popup');
      hiddenHelperCurrentlyActivePopup.setAttribute('data-index',index);
      if(identOfIndexedPopup)
      hiddenHelperCurrentlyActivePopup.value = identOfIndexedPopup;
      
    }

    
  
    function initDefaultQuantity(quantity){
      const quantitySelectElement = document.querySelector('#quantity-select');
      quantitySelectElement.value = quantity;
      document.querySelector('form.key-product input[name="quantity"]').value = quantity;
    }
    
    function updateQuantityOptionsWhenVariantChanges(){
      // get the price of the currently selected variant
      const currentlySelectedVariantId = document.querySelector('.product-variant-id').value;
      const variantElement = variantData.querySelector(`[data-variant-id="` + currentlySelectedVariantId+ `"]`);
      
      
      const newPrice = variantElement.getAttribute('data-variant-price') + "";
      
      // New options to be added
      const newOptions = [
        { value: '1', text: '1 Stück je ' + newPrice },
        { value: '2', text: '2 Stück je ' + newPrice },
        { value: '3', text: '3 Stück je ' + newPrice },
        { value: '4', text: '4 Stück je ' + newPrice },
        { value: '5', text: '5 Stück je ' + newPrice },
        { value: '6', text: '6 Stück je ' + newPrice }
      ];
      replaceSelectOptions("quantity-select",newOptions);
    }
    
    function makeLicensePlatePreviewClickable(){
      var licensePlatePreviewElement = document.querySelector('.plate-preview');
      var textFieldToFocus = document.querySelector('#areaCodeInput');
      if (licensePlatePreviewElement) {
          licensePlatePreviewElement.addEventListener('click', function() {
              textFieldToFocus.focus();
              
          });
      }
    }

    function makeChangeSizeButtonClickable(){
      var changeSizeButton = document.querySelector('.change-size');
      var changeSizeDropdown = document.querySelector('#size-select');
      if (changeSizeButton) {
          changeSizeButton.addEventListener('click', function() {
              changeSizeDropdown.click();
              
          });
      }
    }
    
   function hasLeadingZeros(str) {
        // Use a regular expression to check if the string has leading zeros
        const regex = /^0+/;
        return regex.test(str);
    }

    function toggleAddToCartButtonState(){
      const currentlySelectedVariantId = document.querySelector('.product-variant-id').value;
      const variantElement = variantData.querySelector(`[data-variant-id="` + currentlySelectedVariantId+ `"]`);
      
      let maxLength = 8; // init
      // now fetch the max length for the given variant
      const variantMaxLength = variantElement.getAttribute('data-variant-maxlength');
      if(variantMaxLength > 0)
        maxLength = variantMaxLength;

      const totalLength = areaCodeInput.value.length + lettersInput.value.length + digitsInput.value.length;

      //console.log("Validation: TotalLength "+totalLength + " - Max Length " + maxLength);
      
      let isValidated = false;
      let isValidatedSeason = false;
      let atcButtonText = "In den Warenkorb";
      if (variantElement.getAttribute('data-variant-available') === 'true'){
        isValidated = true; 
        //console.log("Validation: Variant is available");
      }else{
        isValidated = false;
        //console.log("Validation: Variant is NOT available");
      }

      if(totalLength !== 0 && isValidated){ 
        isValidated = true;
        //console.log("Validation: License Plate Text is not empty");
      }else{
        isValidated = false;
        //console.log("Validation: License Plate Text IS empty");
      }

      if(areaCodeInput.value.length !== 0 && isValidated){ 
        isValidated = true;
        //console.log("Validation: License Plate Area Text is not empty");
      }else{
        isValidated = false;
        //console.log("Validation: License Plate Area Text IS empty");
      }

      if(lettersInput.value.length !== 0 && isValidated){ 
        isValidated = true;
        //console.log("Validation: License Plate Letters Text is not empty");
      }else{
        isValidated = false;
        //console.log("Validation: License Plate Letters Text IS empty");
      }

      if(digitsInput.value.length !== 0 && isValidated){ 
        isValidated = true;
        //console.log("Validation: License Plate Digits Text is not empty");
      }else{
        isValidated = false;
        //console.log("Validation: License Plate Digits Text IS empty");
      }

      if(!hasLeadingZeros(digitsInput.value) && isValidated){ 
        isValidated = true;
        //console.log("Validation: License Plate Digits Text is not empty");
      }else{
        isValidated = false;
        //console.log("Validation: License Plate Digits Text IS empty");
      }
      

      if(totalLength <= maxLength && isValidated){
        isValidated = true;
        //console.log("Validation: License Plate Text is NOT too long");
      }else{
        isValidated = false;
        //console.log("Validation: License Plate Text is too long");
      }

      let upsellSeasonStart;
      let upsellSeasonEnd;
      
      if(document.getElementById("season-start-select"))
      upsellSeasonStart = document.getElementById("season-start-select").value;
      
      if(document.getElementById("season-end-select"))
      upsellSeasonEnd = document.getElementById("season-end-select").value;
      
      if (productMetafields.is_season) {
        if(upsellSeasonStart > 0 && upsellSeasonEnd > 0){
          isValidatedSeason = true;
        }else{
          isValidatedSeason = false;
        }
      }else{
        isValidatedSeason = true;
      }
      
      
      if (isValidated && isValidatedSeason) {
        atcButton.classList.remove('disabled');
        atcButton.removeAttribute('disabled');

        if(atcButtonFake){
          atcButtonFake.classList.remove('disabled');
          atcButtonFake.removeAttribute('disabled');
        }
      } else {
        atcButton.classList.add('disabled');
        atcButton.setAttribute('disabled', '');
        atcButtonText = "Kennzeichen eingeben";
        if (productMetafields.is_season) {
          if((!upsellSeasonStart > 0 || !upsellSeasonEnd > 0) && isValidated){
            atcButtonText = "Saison auswählen";
          }
        }

        if(atcButtonFake){
          atcButtonFake.classList.add('disabled');
          atcButtonFake.setAttribute('disabled', '');
        }
      }

      const spanOfButton = atcButton.querySelector('span');
      var buttonText = spanOfButton.childNodes[0];
      buttonText.nodeValue= atcButtonText;

      const spanOfButtonFake = atcButtonFake.querySelector('span');
      var buttonTextFake = spanOfButtonFake.childNodes[0];
      buttonTextFake.nodeValue= atcButtonText;
    }

    function updateCompareAtDisplayPrices(){
      const currentlySelectedVariantId = document.querySelector('.product-variant-id').value;
      const variantElement = variantData.querySelector(`[data-variant-id="` + currentlySelectedVariantId+ `"]`);

      const priceDiffAbs = variantElement.getAttribute('data-variant-price-compareat-diff-abs');
      const priceDiffRel = variantElement.getAttribute('data-variant-price-compareat-diff-rel');
      const priceCompareAt = variantElement.getAttribute('data-variant-price-compareat');

      let updatedString = "";
      updatedString = priceDiffAbs + "(" + priceDiffRel + ")";
      //console.log(updatedString);

      

      const priceElementsToUpdate = document.querySelectorAll('.compareAtReplacer');
      priceElementsToUpdate.forEach(element => {
        element.innerHTML = updatedString;
      });

      // also update the strike price
      const strikePriceElementsToUpdate = document.querySelectorAll('.strike-price');
      strikePriceElementsToUpdate.forEach(element => {
        element.innerHTML = priceCompareAt;
      });
      
    }
    
    function updateDisplayPrice(price){
      const priceElementsToUpdate = document.querySelectorAll('.main-price span.price-holder');
//      console.log(priceElementsToUpdate);

      priceElementsToUpdate.forEach(element => {
        element.innerHTML = price;
      });
    }
    
    // Function to convert price string to a number
    function parsePrice(price) {
      // Remove the currency sign
      let numberString = price.replace('€', '').trim();
      // Replace comma with dot for decimal point
      numberString = numberString.replace(',', '.');
      // Convert to number
      return parseFloat(numberString);
    }
    
    function updatePreview(withAnimations=true) {
      const currentlySelectedVariantId = document.querySelector('.product-variant-id').value;
      const previewContainer = document.getElementById('kz-preview');
      const platePreviewElement = document.querySelector('.plate-preview');
      const variantElement = variantData.querySelector(`[data-variant-id="` + currentlySelectedVariantId+ `"]`);
      const maxLengthPlateSpan = document.querySelector('.maxPlateLength');
      const areaCode = areaCodeInput.value.toUpperCase();
      const letters = lettersInput.value.toUpperCase();
      const digits = digitsInput.value;
      const totalLength = areaCode.length + letters.length + digits.length;
      const regex = /[^A-Z]/;
      let seasonStartValue = 0;
      if(seasonStartSelect)
      seasonStartValue = seasonStartSelect.value;

      let seasonEndValue = 0;
      if(seasonEndSelect)
      seasonEndValue = seasonEndSelect.value;
      
      // also update any other license plate previews the page has
      const anyPlatePreviewElements = document.querySelectorAll('.any-plate-preview');

      
      let maxLength = 8; // init
      // now fetch the max length for the given variant
      const variantMaxLength = variantElement.getAttribute('data-variant-maxlength');
      if(variantMaxLength > 0)
        maxLength = variantMaxLength;

      const variantWidth = variantElement.getAttribute('data-variant-width');
      const variantHeight = variantElement.getAttribute('data-variant-height');

      const removeItems = [
          'w520', 'w480', 'w460', 'w420', 'w400', 'w340', 'w320', 'w280', 'w255', 'w240', 'w220', 'w200', 'w180',
          'h110', 'h130', 'h200'
      ];
      platePreviewElement.classList.remove(...removeItems);
      platePreviewElement.classList.add('w'+variantWidth);
      platePreviewElement.classList.add('h'+variantHeight);

      if(anyPlatePreviewElements){
        anyPlatePreviewElements.forEach(anElement => {
          anElement.classList.remove(...removeItems);
          anElement.classList.add('w'+variantWidth);
          anElement.classList.add('h'+variantHeight);
        });
      }
      
      const anyAreaCodePreviews = document.querySelectorAll(".any-area-code");
      const anyAreaImages = document.querySelectorAll(".any-area-image");
      const anyLettersPreviews = document.querySelectorAll(".any-letters");
      const anyDigitsPreviews = document.querySelectorAll(".any-digits");
      const anySuffixPreviews = document.querySelectorAll(".any-suffix");
      const stickerBadgeText = document.querySelectorAll(".sticker-badge-text");
      const anySeasonStartPreview = document.querySelectorAll(".any-season-start");
      const anySeasonEndPreview = document.querySelectorAll(".any-season-end");

      if(anyAreaCodePreviews){
        anyAreaCodePreviews.forEach(anAreaCodePreview => {
          anAreaCodePreview.textContent = areaCode;
        });
      }
      if(anyLettersPreviews){
        anyLettersPreviews.forEach(aLettersPreview => {
          aLettersPreview.textContent = letters;
        });
      }
      if(anyDigitsPreviews){
        anyDigitsPreviews.forEach(aDigitsPreview => {
          aDigitsPreview.textContent = digits;
        });
      }
      
      //console.log("Max Length:" + maxLength + " - Variant Max Length: " +variantMaxLength);
  
      areaCodePreview.textContent = areaCode;
      lettersPreview.textContent = letters;
      digitsPreview.textContent = digits;
  
      let suffix = '';
  
      if (productMetafields.is_electric) {
        suffix = 'E';
        // maxLength = 7; // this is not needed anymore as the maxLength is stored in the variants now
      } else if (productMetafields.is_historic) {
        suffix = 'H';
        // maxLength = 7; // this is not needed anymore as the maxLength is stored in the variants now
      }else{
        // maxLength = 8; // this is not needed anymore as the maxLength is stored in the variants now
      }
      maxLengthPlateSpan.innerHTML = maxLength;
      suffixPreview.textContent = suffix;

      if(anySuffixPreviews){
        anySuffixPreviews.forEach(aSuffixPreview => {
          aSuffixPreview.textContent = suffix;
        });
      }

      if(stickerBadgeText){
        stickerBadgeText.forEach(aStickerBadgeText => {
          aStickerBadgeText.textContent = areaCode+"-"+letters+" "+digits+""+suffix;
        });
      }
  
      if (regex.test(letters) || totalLength > maxLength || hasLeadingZeros(digitsInput.value)) {
        if (totalLength > maxLength) {
          inputErrorMessage.classList.add('active');
          inputErrorMessage2.classList.remove('active'); // this is here as the length error supercedes all other errors
        }else{
          inputErrorMessage.classList.remove('active');
          if (regex.test(letters)) {
            inputErrorMessage2.classList.add('active');
           
            var errorText = inputErrorMessage2.querySelector('.error-letters-only').textContent;
            inputErrorMessage2.querySelector('.error-text').textContent=errorText;
          }
          if(hasLeadingZeros(digitsInput.value)){
            inputErrorMessage2.classList.add('active');
            var errorText = inputErrorMessage2.querySelector('.error-no-leading-zeros').textContent;
            inputErrorMessage2.querySelector('.error-text').textContent=errorText;
          }
          
        }
      } else {
        inputErrorMessage.classList.remove('active');
        inputErrorMessage2.classList.remove('active');
        
        //toggleAddToCartButtonState();
        
      }

     
  
      if (areaCode) {
        let imageUrl = '';
        if (areaCodeImageMapping[areaCode]) {
          imageUrl = areaCodeImageMapping[areaCode];
        } else if (bayernCodes.includes(areaCode)) {
          imageUrl = "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/bayern.png?v=1716625754";
        } else if (badenWuerttembergCodes.includes(areaCode)) {
          imageUrl = "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/baden-wuerttemberg.png?v=1716625754";
        } else if (brandenburgCodes.includes(areaCode)) {
          imageUrl = "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/brandenburg.png?v=1716625754";
        } else if (hessenCodes.includes(areaCode)) {
          imageUrl = "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/hessen.png?v=1716625754";
        } else if (mecklenburgVorpommernCodes.includes(areaCode)) {
          imageUrl = "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/mecklenburg-vorpommern.png?v=1716625754";
        } else if (niedersachsenCodes.includes(areaCode)) {
          imageUrl = "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/niedersachsen.png?v=1716625754";
        } else if (nordrheinWestfalenCodes.includes(areaCode)) {
          imageUrl = "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/nrw.png?v=1716625754";
        } else if (rheinlandPfalzCodes.includes(areaCode)) {
          imageUrl = "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/rheinland-pfalz.png?v=1716625755";
        } else if (saarlandCodes.includes(areaCode)) {
          imageUrl = "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/saarland.png?v=1716625754";
        } else if (sachsenCodes.includes(areaCode)) {
          imageUrl = "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/sachsen.png?v=1716625754";
        } else if (sachsenAnhaltCodes.includes(areaCode)) {
          imageUrl = "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/sachsen-anhalt.png?v=1716625755";
        } else if (schleswigHolsteinCodes.includes(areaCode)) {
          imageUrl = "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/schleswig-holstein.png?v=1716625754";
        } else if (thuringenCodes.includes(areaCode)) {
          imageUrl = "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/thueringen.png?v=1716625754";            
        } else if (areaCodeImageMapping[areaCode.charAt(0)]) {
          imageUrl = areaCodeImageMapping[areaCode.charAt(0)];
        } else {
          imageUrl = '';
        }
        
        areaImage.src = imageUrl;
        areaImage.style.display = 'inline';
        
        if(anyAreaImages){
          anyAreaImages.forEach(anAreaImage => {
            anAreaImage.src = imageUrl;
            anAreaImage.style.display = 'inline';
          });  
        }
      } else {
        areaImage.style.display = 'none';
        if(anyAreaImages){
          anyAreaImages.forEach(anAreaImage => {
            anAreaImage.style.display = 'none';
          });  
        }
      }
  
      
      previewContainer.classList.remove('carbon', 'tax-exempt', 'season');
      suffixPreview.classList.remove('carbon');
  
      if (productMetafields.is_carbon) {
        previewContainer.classList.add('carbon');
      }
  
      if (productMetafields.is_tax_exempt) {
        previewContainer.classList.add('tax-exempt');
      }

      if (productMetafields.is_season) {
        previewContainer.classList.add('season');
        if(anySeasonStartPreview){
          let displaySeasonStartValue;
          
          if(seasonStartValue > 0 && seasonStartValue <10){
            displaySeasonStartValue = "0" + seasonStartValue;
          }else{
            displaySeasonStartValue = seasonStartValue;
          }
          if(!seasonStartValue || seasonStartValue == 0)
            displaySeasonStartValue = "00";
          anySeasonStartPreview.forEach(aSeasonStartPreview => {
            aSeasonStartPreview.textContent = displaySeasonStartValue;
          });
        }

        if(anySeasonEndPreview){
          let displaySeasonEndValue;
          
          if(seasonEndValue > 0 && seasonEndValue <10){
            displaySeasonEndValue = "0" + seasonEndValue;
          }else{
            displaySeasonEndValue = seasonEndValue;
          }
          if(!seasonEndValue || seasonEndValue == 0)
            displaySeasonEndValue = "00";
          anySeasonEndPreview.forEach(aSeasonEndPreview => {
            aSeasonEndPreview.textContent = displaySeasonEndValue;
          });
        }
      }

      if (productMetafields.is_carbon && productMetafields.is_electric) {
        suffixPreview.classList.add('carbon');
      } else {
        suffixPreview.classList.remove('carbon');
      }

      // adjust the font size according to the length
      platePreviewElement.classList.remove('small');
      platePreviewElement.classList.remove('medium');
      platePreviewElement.classList.remove('large');

      if (productMetafields.is_electric || productMetafields.is_historic) {
       if(totalLength<5){
          platePreviewElement.classList.add('large');
        }else if(totalLength >= 5 && totalLength <7){
          platePreviewElement.classList.add('medium');
        }else{
          platePreviewElement.classList.add('small');
        }
      } else {
        if(totalLength<6){
          platePreviewElement.classList.add('large');
        }else if(totalLength >= 6 && totalLength <8){
          platePreviewElement.classList.add('medium');
        }else{
          platePreviewElement.classList.add('small');
        }  
      }

      var resetTriggerElement = document.querySelector('button.reset-trigger');
      if(totalLength > 0){
        resetTriggerElement.classList.remove('hidden');
      }else{
        resetTriggerElement.classList.add('hidden');
      }
      toggleAddToCartButtonState();
      
    }

    function updateAddonQuantities(quantity){
     // console.log("Changing quantity to ", quantity);
      // cycle through all addons
      document.querySelectorAll('.featured-product.sync-quantity').forEach(element => {
        // read the respective max quantity
        let tmpMaxQuantity = element.getAttribute('data-max-quantity');
        let tmpUpdateQuantity = quantity;
        if(quantity > tmpMaxQuantity){
          tmpUpdateQuantity = tmpMaxQuantity;
        }
        // update the visible text
        element.querySelector('.quantity-indicator').textContent = tmpUpdateQuantity + "x";
        // update the hidden input
        element.querySelector('.addon-quantity-input').value = tmpUpdateQuantity;

        
      });
    }

    var resetTriggerElement = document.querySelector('button.reset-trigger');
    resetTriggerElement.addEventListener('click', resetLicensePlate);

    function resetLicensePlate(){
      areaCodeInput.value="";
      lettersInput.value="";
      digitsInput.value="";
      updatePreview();
      areaCodeInput.focus();
    }
    
    var faqItems = document.querySelectorAll('.product-faqs .a-faq');
    if(faqItems){
      faqItems.forEach(function (faqItem) {
          var question = faqItem.querySelector('.a-faq-question');
          const ident = faqItem.getAttribute('data-ident');
          question.addEventListener('click', function () {
  
              // close all other currently open ones
              faqItems.forEach(function (item) {
                  //item.classList.add('closed');
              });
            
              faqItem.classList.toggle('closed');

              const currentlySelectedVariantId = document.querySelector('.product-variant-id').value;
              const variantElement = variantData.querySelector(`[data-variant-id="` + currentlySelectedVariantId+ `"]`);
              const variantTitle = variantElement.getAttribute('data-variant-title');
              const variantProductId = variantElement.getAttribute('data-product-id');
              const variantVariantId = variantElement.getAttribute('data-variant-id');
              const variantProductTitle = variantElement.getAttribute('data-product-title');
              const variantPriceClean = variantElement.getAttribute('data-variant-price-clean');
              let prodIdString = "shopify_DE_" + variantProductId + "_" + variantVariantId;

              if (typeof gtag !== 'undefined') {
                gtag('event', 'faq_read', {
                  'faq_ident': ident,
                  'items': [{
                    'id': prodIdString, // e.g. "shopify_DE_9373908402524_48769079771484",
                    'name': variantProductTitle,
                    'variant': variantTitle,
                    'price': (variantPriceClean/100)
                  }],
                  'ecomm_pagetype': 'product',
                  'ecomm_prodid': [prodIdString]
                });
              }
          });
      });
    }

    var productDescriptionElement = document.querySelector('.product-description');
    if(productDescriptionElement){
      productDescriptionElement.addEventListener('click', function () {
          productDescriptionElement.classList.toggle('closed');
      });
    }

    var productHowToElement = document.querySelector('.product-how-to');
    if(productHowToElement){
      productHowToElement.addEventListener('click', function () {
          productHowToElement.classList.toggle('closed');
      });
    }
    
    function updateSizePrices(){
      const sizeOptions = document.querySelector('#size-select');
      const sizeOptionsDummy = document.querySelector('.size-option-dummy');
      // first get the currently active variant and its respective price
      const currentlySelectedVariantId = document.querySelector('.product-variant-id').value;
      const variantElement = variantData.querySelector(`[data-variant-id="` + currentlySelectedVariantId+ `"]`);
      const currentVariantsPrice = parsePrice(variantElement.getAttribute('data-variant-price'));

     // console.log("Current Variants Price is ", currentVariantsPrice);

      // New options to be added
      let newOptions = [
       
      ];
      
      // then iterate over all product variants and compare the currently active price with the othe variants prices
      variantData.querySelectorAll('span').forEach(element => {
        //console.log("Variant Data: ", element);
        let tmpVariantPrice = parsePrice(element.getAttribute('data-variant-price'));
        let tmpVariantId = element.getAttribute('data-variant-id');
        let tmpVariantTitle = element.getAttribute('data-variant-title');
  
        let priceDiff = tmpVariantPrice - currentVariantsPrice;
        //priceDiff = priceDiff.toFixed(2);
        const formattedPriceDifference = priceDiff.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        //console.log("Compare Variant Price is ", tmpVariantPrice);
        //console.log("Price Difference is ", priceDiff);
        let newTextWithPrice = tmpVariantTitle;
        if(priceDiff > 0){
          newTextWithPrice =tmpVariantTitle + ' (+'+formattedPriceDifference+'€)';
        }else if (priceDiff < 0){
          newTextWithPrice =tmpVariantTitle + ' ('+formattedPriceDifference+'€)';
        }
        
        newOptions.push({
          value: tmpVariantId,
          text: newTextWithPrice
        });
        
      });
     // console.log(newOptions);
      

      // then update the prices in the size select
      replaceSelectOptions("size-select",newOptions);
    }

    const breadcrumbSelect = document.querySelector('.breadcrumbs-container select');
    if(breadcrumbSelect){
      breadcrumbSelect.addEventListener('change', () => {
        // construct the URL to carry over size and any other customizations
        document.location = breadcrumbSelect.value;
      });
    }
  
    function whenSizeChanges(){
      //console.log('sizeOptions changed');
      // Select the element with the class "size-options"
      const sizeOptions = document.querySelector('#size-select');
      const sizeOptionsDummy = document.querySelector('.size-option-dummy');

      sizeOptionsDummy.value = sizeOptions.value;
      // Read the value of the selected option
      const variantId = sizeOptions.value;
      //console.log("Changing sizes. Variant now is ", variantId);
      const variantElement = variantData.querySelector(`[data-variant-id="` + variantId+ `"]`);
      const variantTitle = variantElement.getAttribute('data-variant-title');
      const variantProductTitle = variantElement.getAttribute('data-product-title');
      const variantProductId = variantElement.getAttribute('data-product-id');
      const variantVariantId = variantElement.getAttribute('data-variant-id');
      const variantPriceClean = variantElement.getAttribute('data-variant-price-clean');

      let prodIdString = "shopify_DE_" + variantProductId + "_" + variantVariantId;
      
      document.querySelector('form input.product-variant-id').value = variantId;
      //console.log("Selected Variant ID: ", variantId);

      // also trigger a GA4 event as the user is now viewing a different item with different parameters (e.g. price)
      if (typeof gtag !== 'undefined') {
        console.log('GTAG OK');
        gtag('event', 'view_item', {
          'items': [{
            'id': prodIdString, // e.g. "shopify_DE_9373908402524_48769079771484",
            'name': variantProductTitle,
            'variant': variantTitle,
            'price': (variantPriceClean/100)
          }],
          'ecomm_pagetype': 'product',
          'ecomm_prodid': [prodIdString]
        });
      }
      
      updateDisplayPrice(variantElement.getAttribute('data-variant-price'));
      updateCompareAtDisplayPrices();
      updateQuantityOptionsWhenVariantChanges();
      updateSizePrices();
      updatePreview();
      toggleAddToCartButtonState();
    }
    sizeOptions.addEventListener('change', () => {
      whenSizeChanges();
    });

    
  
    if(carbonUpsellCheckbox){
      carbonUpsellCheckbox.addEventListener('change', () => {
        
        const activeMaterial = document.querySelector('input.material-helper.active');
        const inactiveMaterial = document.querySelector('input.material-helper:not(.active)');
        
        const currentlySelectedVariantId = document.querySelector('.product-variant-id').value;
        const variantElement = variantData.querySelector(`[data-variant-id="` + currentlySelectedVariantId+ `"]`);
        const variantTitle = variantElement.getAttribute('data-variant-title');
        const variantProductId = variantElement.getAttribute('data-product-id');
        const variantVariantId = variantElement.getAttribute('data-variant-id');
        const variantProductTitle = variantElement.getAttribute('data-product-title');
        const variantPriceClean = variantElement.getAttribute('data-variant-price-clean');
        
  
        if(!activeMaterial)
          return;
  
        if(!inactiveMaterial)
          return;
        
       // console.log(activeMaterial);
       // console.log(inactiveMaterial);
        
        const prependArea = areaCodeInput.value;
        const prependLetters = lettersInput.value;
        const prependDigits = digitsInput.value;
        
        let prependSeasonStart = 0;
        if(seasonStartSelect)
        prependSeasonStart = seasonStartSelect.value;
        
        let prependSeasonEnd = 0;
        if(seasonEndSelect)
        prependSeasonEnd = seasonEndSelect.value;
        
        const sizeHelper = document.querySelector(`.size-helper[data-variant-id="` + currentlySelectedVariantId+ `"]`);
        //console.log(sizeHelper);
        let widthOfVariant;
        let heightOfVariant;
        if(sizeHelper){
          widthOfVariant = sizeHelper.getAttribute('data-variant-width');
          heightOfVariant = sizeHelper.getAttribute('data-variant-height');
        }
        
        let handle;
        
        if(carbonUpsellCheckbox.checked){
          if (productMetafields.is_carbon) {
            handle = activeMaterial.getAttribute('data-handle');
          }else{
            handle = inactiveMaterial.getAttribute('data-handle');
          }
        }else{
          if (productMetafields.is_carbon) {
            handle = inactiveMaterial.getAttribute('data-handle');
          }else{
            handle = activeMaterial.getAttribute('data-handle');
          }
        }
        let newHref = window.location.origin + `/products/${handle}`;
        var url = new URL(newHref);
        
        if(prependArea)
          url.searchParams.append('area',prependArea);
        if(prependDigits)
          url.searchParams.append('digits',prependDigits);
        if(prependLetters)
          url.searchParams.append('letters',prependLetters);
        if(prependSeasonStart > 0)
          url.searchParams.append('start',prependSeasonStart);
        if(prependSeasonEnd > 0)
          url.searchParams.append('end',prependSeasonEnd);


        if(widthOfVariant)
          url.searchParams.append('width',widthOfVariant);
        if(heightOfVariant)
          url.searchParams.append('height',heightOfVariant);

        if (typeof gtag !== 'undefined') {
          let prodIdString = "shopify_DE_" + variantProductId + "_" + variantVariantId;
          gtag('event', 'upsell_interacted', {
            'items': [{
              'id': prodIdString, // e.g. "shopify_DE_9373908402524_48769079771484",
              'name': variantProductTitle,
              'variant': variantTitle,
              'price': (variantPriceClean/100)
            }],
            'ecomm_pagetype': 'product',
            'ecomm_prodid': [prodIdString]
          });
        }
        
        window.location.href = url;
      });
    }

    function switchToE(){
      const currentlySelectedVariantId = document.querySelector('.product-variant-id').value;

      const variantElement = variantData.querySelector(`[data-variant-id="` + currentlySelectedVariantId+ `"]`);
      const productHandle = variantElement.getAttribute('data-product-handle');
      

      if(productHandle != 'auto')
        return;
      
      const prependArea = areaCodeInput.value;
      const prependLetters = lettersInput.value;
      const prependDigits = digitsInput.value;
      
      
      const sizeHelper = document.querySelector(`.size-helper[data-variant-id="` + currentlySelectedVariantId+ `"]`);
      //console.log(sizeHelper);
      let widthOfVariant;
      let heightOfVariant;
      if(sizeHelper){
        widthOfVariant = sizeHelper.getAttribute('data-variant-width');
        heightOfVariant = sizeHelper.getAttribute('data-variant-height');
      }
      
      let handle;
      handle = 'e-kennzeichen';
      let newHref = window.location.origin + `/products/${handle}`;
      var url = new URL(newHref);
      
      if(prependArea)
        url.searchParams.append('area',prependArea);
      if(prependDigits)
        url.searchParams.append('digits',prependDigits);
      if(prependLetters)
        url.searchParams.append('letters',prependLetters);

      if(widthOfVariant)
        url.searchParams.append('width',widthOfVariant);
      if(heightOfVariant)
        url.searchParams.append('height',heightOfVariant);

      window.location.href = url;
    }

    if(seasonStartSelect){
      seasonStartSelect.addEventListener('change', () => {
        toggleAddToCartButtonState();
        updatePreview();
      });
    }
    if(seasonEndSelect){
      seasonEndSelect.addEventListener('change', () => {
        toggleAddToCartButtonState();
        updatePreview();
      });
    }
  
    quantitySelect.addEventListener('change', () => {
      
      // Select the element with the class "size-options"
      const quantitySelectElement = document.querySelector('#quantity-select');
      
      // Read the value of the selected option
      const quantity = quantitySelectElement.value;
      
      document.querySelector('form.key-product input[name="quantity"]').value = quantity;
      //priceElement.innerText = variantElement.getAttribute('data-variant-price');
      //eleToUpdate.forEach(element => {
      //  element.innerHTML = formattedDate;
      //});
      updateAddonQuantities(quantity);
      toggleAddToCartButtonState();
    });

    atcButton.setAttribute('disabled', '');

    document.getElementById('digitsInput').addEventListener('input', function (e) {
      const value = e.target.value;
      if (value.endsWith('e') || value.endsWith('E')) {
          // Show an alert
          //alert('You have typed a hyphen or a whitespace!');
      }
      this.value = this.value.replace(/[^0-9]/g, '');
    });

    areaCodeInput.addEventListener("input", function(e) {
      const value = e.target.value;
      let moveOverToNext = false;
      if (value.endsWith('-') || value.endsWith(' ') || value.length == 3) {
          //move over to next input
        moveOverToNext = true;
      }
      
      if(value.length ==1)
        moveOverToNext = false;
      
      this.value = this.value.toUpperCase().replace(/[^A-ZÄÖÜ]/g, '');
      if(moveOverToNext)
        lettersInput.focus();
    });

    lettersInput.addEventListener("input", function(e) {
      const value = e.target.value;
      let moveOverToNext = false;
      if (value.endsWith('-') || value.endsWith(' ') || value.length == 2) {
          //move over to next input
        moveOverToNext = true;
      }
      
      if(value.length ==1)
        moveOverToNext = false;
      
      this.value = this.value.toUpperCase().trim();

      if(moveOverToNext)
        digitsInput.focus();
    });

    document.addEventListener('keydown', function(event) {
        // Check if the key pressed is 'E' (both uppercase and lowercase)
        if (event.key === 'E' || event.key === 'e') {
          if (document.activeElement && document.activeElement.classList.contains('listen-for-e')) {
            if(digitsInput.value!="")
            switchToE();
          }
        }
    });

    
  
    areaCodeInput.addEventListener("input", updatePreview);
    lettersInput.addEventListener("input", updatePreview);
    digitsInput.addEventListener("input", updatePreview);

    checkForPrefilling();
    updatePreview();
    var eleToUpdateForDeliveryETA = document.querySelectorAll('strong.delivery-date-eta');
    setDeliveryETA(eleToUpdateForDeliveryETA);
    makeLicensePlatePreviewClickable();
    makeChangeSizeButtonClickable();
    initDefaultQuantity(productMetafields.default_quantity);
    initSizeDummy();
    initTooltipsForFeatures();
    initTooltipsForCertificates();
    initTooltipsForShipping();
    checkForUpsellInterceptors();
    //displayTooltipHintForMenu();
});